import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as RT from '../../../constants/Routing'
import { withRouter } from 'react-router-dom';
import * as Actions from '../../../actions/User/SignIn';

class Component extends React.Component {
  componentDidMount = () => {
    // const params = this.props.location.search
    // const token = params.replace(/\?token=/, '')
    // this.props.googleSignInResult(token)
    // console.log('google did mount')
    if (localStorage.getItem('token')) {
      if (this.props.App.currentUser) {

      } else {
        this.props.signInCheckForSns()
      }
    } else {
      const params = this.props.location.search
      const token = params.replace(/\?token=/, '')
      // console.log('Did Mount', token, this.props)
      this.props.googleSignInResult(token)
    }

  }

  componentWillReceiveProps = (nextProps) => {
    // console.log('will receive props')
    if (nextProps.SignIn.googleRedirect || (nextProps.App.currentUser && localStorage.getItem('token'))) {
      // console.log('Google認証後 リダイレクト', this.props)
      const { history } = this.props
      history.push(RT.USER_MYPAGE_PATH)
    }
  }

  render = () => {
    // console.log('google callback',this.props)
    return (
      <div>Google認証情報を読み込み中...</div>
    )
  }
}


const mapStateToProps = (state) => {
  return state
};

const mapDispatchToProps = (dispatch) => (bindActionCreators(Actions, dispatch));


const Container = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Component);

export default withRouter(Container);


// WEBPACK FOOTER //
// ./src/components/User/SignIn/googleCallback.jsx